import Button, { Theme } from "theme/components/buttons/Button";

import React from "react";
import colors from "theme/config/colors";

const BlackOutlinedButton = (props: any) => {
    const theme: Theme = {
        color: colors.black,
        borderColor: colors.black,
        hover: {
            backgroundColor: colors.neutral_700,
            color: colors.white,
            borderColor: colors.neutral_700,
        },
        active: {
            backgroundColor: colors.black,
            color: colors.white,
            borderColor: colors.black,
        },
        selected: {
            backgroundColor: colors.white,
            borderColor: colors.blue_700,
        },
        disabled: {
            opacity: "30%",
        },
    };

    return <Button {...props} theme={theme} />;
};

export default BlackOutlinedButton;
